import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white border-t border-slate-200/60" }
const _hoisted_2 = { class: "hidden md:flex items-center justify-between px-6 py-4" }
const _hoisted_3 = { class: "text-sm text-slate-500" }
const _hoisted_4 = { class: "flex items-center gap-1" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "min-w-[36px] h-9 flex items-center justify-center text-slate-400"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "md:hidden px-4 py-4" }
const _hoisted_10 = { class: "flex items-center justify-between gap-3" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "flex items-center gap-1.5" }
const _hoisted_13 = { class: "w-9 h-9 flex items-center justify-center text-sm font-bold rounded-lg bg-slate-900 text-white" }
const _hoisted_14 = {
  key: 2,
  class: "text-slate-400 text-xs px-1"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "text-center text-xs text-slate-400 mt-3" }

import { computed } from 'vue';

interface Props {
  currentPage: number;
  totalPages: number;
  total: number;
  limit: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationCompontens',
  props: {
    currentPage: {},
    totalPages: {},
    total: {},
    limit: {}
  },
  emits: ["pageChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const getPaginationRange = computed(() => {
  const range = [];
  const delta = 1;
  const left = Math.max(2, props.currentPage - delta);
  const right = Math.min(props.totalPages - 1, props.currentPage + delta);

  if (left > 2) range.push('...');
  for (let i = left; i <= right; i++) {
    range.push(i);
  }
  if (right < props.totalPages - 1) range.push('...');

  return range;
});

const startItem = computed(() => (props.currentPage - 1) * props.limit + 1);
const endItem = computed(() => Math.min(props.currentPage * props.limit, props.total));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(startItem.value) + "–" + _toDisplayString(endItem.value) + " ", 1),
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-slate-400" }, "de", -1)),
        _createTextVNode(" " + _toDisplayString(__props.total), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('pageChange', __props.currentPage - 1))),
          disabled: __props.currentPage === 1,
          class: _normalizeClass(["p-2 rounded-lg transition-all duration-200", __props.currentPage === 1 
            ? 'text-slate-300 cursor-not-allowed' 
            : 'text-slate-600 hover:bg-slate-100'])
        }, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M15 19l-7-7 7-7"
            })
          ], -1)
        ]))], 10, _hoisted_5),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('pageChange', 1))),
          class: _normalizeClass(["min-w-[36px] h-9 flex items-center justify-center text-sm font-medium rounded-lg transition-all duration-200", 1 === __props.currentPage 
            ? 'bg-slate-900 text-white' 
            : 'text-slate-600 hover:bg-slate-100'])
        }, " 1 ", 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPaginationRange.value, (page) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
            (page === '...')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " ··· "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: ($event: any) => (emit('pageChange', page as number)),
                  class: _normalizeClass(["min-w-[36px] h-9 flex items-center justify-center text-sm font-medium rounded-lg transition-all duration-200", page === __props.currentPage 
              ? 'bg-slate-900 text-white' 
              : 'text-slate-600 hover:bg-slate-100'])
                }, _toDisplayString(page), 11, _hoisted_7))
          ], 64))
        }), 128)),
        (__props.totalPages > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('pageChange', __props.totalPages))),
              class: _normalizeClass(["min-w-[36px] h-9 flex items-center justify-center text-sm font-medium rounded-lg transition-all duration-200", __props.totalPages === __props.currentPage 
            ? 'bg-slate-900 text-white' 
            : 'text-slate-600 hover:bg-slate-100'])
            }, _toDisplayString(__props.totalPages), 3))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('pageChange', __props.currentPage + 1))),
          disabled: __props.currentPage === __props.totalPages,
          class: _normalizeClass(["p-2 rounded-lg transition-all duration-200", __props.currentPage === __props.totalPages 
            ? 'text-slate-300 cursor-not-allowed' 
            : 'text-slate-600 hover:bg-slate-100'])
        }, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 5l7 7-7 7"
            })
          ], -1)
        ]))], 10, _hoisted_8)
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "w-32" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('pageChange', __props.currentPage - 1))),
          disabled: __props.currentPage === 1,
          class: _normalizeClass(["flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-all", __props.currentPage === 1 
            ? 'text-slate-300 bg-slate-50 cursor-not-allowed' 
            : 'text-slate-700 bg-slate-100 hover:bg-slate-200 active:scale-95'])
        }, [...(_cache[12] || (_cache[12] = [
          _createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M15 19l-7-7 7-7"
            })
          ], -1),
          _createElementVNode("span", { class: "hidden xs:inline" }, "Anterior", -1)
        ]))], 10, _hoisted_11),
        _createElementVNode("div", _hoisted_12, [
          (__props.currentPage > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('pageChange', __props.currentPage - 1))),
                class: "w-9 h-9 flex items-center justify-center text-sm font-medium rounded-lg text-slate-600 hover:bg-slate-100 transition-all"
              }, _toDisplayString(__props.currentPage - 1), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, _toDisplayString(__props.currentPage), 1),
          (__props.currentPage < __props.totalPages)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('pageChange', __props.currentPage + 1))),
                class: "w-9 h-9 flex items-center justify-center text-sm font-medium rounded-lg text-slate-600 hover:bg-slate-100 transition-all"
              }, _toDisplayString(__props.currentPage + 1), 1))
            : _createCommentVNode("", true),
          (__props.currentPage < __props.totalPages - 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, " ··· "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (emit('pageChange', __props.currentPage + 1))),
          disabled: __props.currentPage === __props.totalPages,
          class: _normalizeClass(["flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-all", __props.currentPage === __props.totalPages 
            ? 'text-slate-300 bg-slate-50 cursor-not-allowed' 
            : 'text-slate-700 bg-slate-100 hover:bg-slate-200 active:scale-95'])
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("span", { class: "hidden xs:inline" }, "Siguiente", -1),
          _createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 5l7 7-7 7"
            })
          ], -1)
        ]))], 10, _hoisted_15)
      ]),
      _createElementVNode("div", _hoisted_16, _toDisplayString(startItem.value) + "–" + _toDisplayString(endItem.value) + " de " + _toDisplayString(__props.total), 1)
    ])
  ]))
}
}

})